const newsSlider = document.querySelectorAll('[data-slider="news-slider"]');

if (newsSlider.length > 0) {
  const newsSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 20,
    watchOverflow: true,
    breakpoints: {
      767: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  };

  const initNewsSlider = () => {
    newsSlider.forEach((el) => {
      const parentEle = el.closest('[data-slider-parent]');

      if (windowWidth() > 767) {
        new Swiper(el, newsSliderOptions);
      } else {
        enableScrollbarSync(parentEle);
      }
    });
  };

  initNewsSlider();

  setupResponsiveSliders({
    sliderElements: newsSlider,
    breakpoint: 767,
    initSlider: initNewsSlider,
    mobileFallback: enableScrollbarSync,
    parentSelector: '[data-slider-parent]',
  });
}
